<!-- <form
  method="post"
  class="form-horizontal"
  id="crudForm"
  autocomplete="off"
  enctype="multipart/form-data"
  accept-charset="utf-8"
>
  <div class="form-div">
    <div class="form-group odd" id="name_field_box">
      <label class="col-sm-3 control-label" for="name" id="name_display_as_box">
        <font style="vertical-align: inherit">
          <font style="vertical-align: inherit">
            {{ memberI18n.nameI18n }}
          </font> </font
        ><span class="required">
          <font style="vertical-align: inherit">
            <font style="vertical-align: inherit">*</font>
          </font>
        </span>
      </label>
      <div class="col-sm-9 col-md-6 col-lg-6" id="name_input_box">
        <input
          class="form-control"
          id="field-name"
          name="name"
          type="text"
          [(ngModel)]="model.name"
          value="{{ model.name }}"
          maxlength="99"
        />
      </div>
    </div>

    <div class="form-group even" id="user_type_field_box">
      <label
        class="col-sm-3 control-label"
        for="name"
        id="user_type_display_as_box"
      >
        <font style="vertical-align: inherit">
          <font style="vertical-align: inherit">
            {{ memberI18n.MemberI18n }}
          </font> </font
        ><span class="required">
          <font style="vertical-align: inherit">
            <font style="vertical-align: inherit">*</font>
          </font>
        </span>
      </label>
      <div class="col-sm-9 col-md-6 col-lg-6" id="user_type_input_box">
        <select class="form-control" name="user_type" id="field-user_type">
          <option value=""></option>
          <option value="Member" selected="yes">
            <font style="vertical-align: inherit">
              <font style="vertical-align: inherit">Membre</font>
            </font>
          </option>
          <option value="Admin">
            <font style="vertical-align: inherit">
              <font style="vertical-align: inherit">Administrateur</font>
            </font>
          </option>
        </select>
      </div>
    </div>

    <div class="form-group odd" id="type_id_field_box">
      <label
        class="col-sm-3 control-label"
        for="name"
        id="type_id_display_as_box"
      >
        <font style="vertical-align: inherit">
          <font style="vertical-align: inherit">
            {{ memberI18n.type_idI18n }}
          </font>
        </font>
      </label>
      <div class="col-sm-9 col-md-6 col-lg-6" id="type_id_input_box">
        <select class="form-control" id="field-type_id" name="type_id">
          <option value=""></option>
          <option value="150">
            <font style="vertical-align: inherit">
              <font style="vertical-align: inherit">Professeur</font>
            </font>
          </option>
          <option value="151">
            <font style="vertical-align: inherit">
              <font style="vertical-align: inherit">Etudiant</font>
            </font>
          </option>
        </select>
      </div>
    </div>

    <div class="form-group even" id="email_field_box">
      <label
        class="col-sm-3 control-label"
        for="name"
        id="email_display_as_box"
      >
        <font style="vertical-align: inherit">
          <font style="vertical-align: inherit">
            {{ memberI18n.emailI18n }}
          </font> </font
        ><span class="required">
          <font style="vertical-align: inherit">
            <font style="vertical-align: inherit">*</font>
          </font>
        </span>
      </label>
      <div class="col-sm-9 col-md-6 col-lg-6" id="email_input_box">
        <input
          class="form-control"
          id="field-email"
          name="email"
          type="text"
          [(ngModel)]="model.email"
          value="{{ model.email }}"
          maxlength="250"
        />
      </div>
    </div>

    <div class="form-group odd" id="mobile_field_box">
      <label
        class="col-sm-3 control-label"
        for="name"
        id="mobile_display_as_box"
      >
        <font style="vertical-align: inherit">
          <font style="vertical-align: inherit">
            {{ memberI18n.mobileI18n }}
          </font> </font
        ><span class="required">
          <font style="vertical-align: inherit">
            <font style="vertical-align: inherit">*</font>
          </font>
        </span>
      </label>
      <div class="col-sm-9 col-md-6 col-lg-6" id="mobile_input_box">
        <input
          class="form-control"
          id="field-mobile"
          name="mobile"
          type="text"
          [(ngModel)]="model.mobile"
          maxlength="100"
          value="{{ model.mobile }}"
        />
      </div>
    </div>

    <div class="form-group even" id="password_field_box">
      <label
        class="col-sm-3 control-label"
        for="name"
        id="password_display_as_box"
      >
        <font style="vertical-align: inherit">
          <font style="vertical-align: inherit">
            {{ memberI18n.passwordI18n }}
          </font> </font
        ><span class="required">
          <font style="vertical-align: inherit">
            <font style="vertical-align: inherit">*</font>
          </font>
        </span>
      </label>
      <div class="col-sm-9 col-md-6 col-lg-6" id="password_input_box">
        <input
          class="form-control"
          id="field-password"
          name="password"
          type="password"
          [(ngModel)]="model.password"
          value="{{ model.password }}"
          maxlength="99"
        />
      </div>
    </div>

    <div class="form-group odd" id="address_field_box">
      <label
        class="col-sm-3 control-label"
        for="name"
        id="address_display_as_box"
      >
        <font style="vertical-align: inherit">
          <font style="vertical-align: inherit">
            {{ memberI18n.addressI18n }}
          </font> </font
        ><span class="required">
          <font style="vertical-align: inherit">
            <font style="vertical-align: inherit">*</font>
          </font>
        </span>
      </label>
      <div class="col-sm-9 col-md-6 col-lg-6" id="address_input_box">
        <textarea
          class="form-control"
          id="field-address"
          name="address"
        ></textarea>
      </div>
    </div>

    <div class="form-group even" id="status_field_box">
      <label
        class="col-sm-3 control-label"
        for="name"
        id="status_display_as_box"
      >
        <font style="vertical-align: inherit">
          <font style="vertical-align: inherit">
            {{ memberI18n.statusI18n }}
          </font> </font
        ><span class="required">
          <font style="vertical-align: inherit">
            <font style="vertical-align: inherit">*</font>
          </font>
        </span>
      </label>
      <div class="col-sm-9 col-md-6 col-lg-6" id="status_input_box">
        <select name="status" class="form-control" id="field-status">
          <option value="0">
            <font style="vertical-align: inherit">
              <font style="vertical-align: inherit">Inactif</font>
            </font>
          </option>
          <option value="1" selected="selected">
            <font style="vertical-align: inherit">
              <font style="vertical-align: inherit">actif</font>
            </font>
          </option>
        </select>
      </div>
    </div>
  </div>
  <div class="pDiv">
    <button (click)="edit()" type="button" class="btn btn-info">
      <i class="fas fa-save"></i>
      {{ memberI18n.editButtonI18n }}
    </button>
  </div>
</form>  -->



<div class="modal-header">
  <h5 class="modal-title" id="emptyModalLabel">Edit Member</h5>
  <button type="button" class="btn-close" (click)="closeModal()" aria-label="Close">x</button>
</div>
<div class="modal-body">
  <form [formGroup]="memberForm" (ngSubmit)="onSubmit()">

    <div class="row">
      <!-- Surname -->
      <div class="form-group col-md-6">
        <label for="surname">
          Surname
          <i class="fas fa-info-circle" data-toggle="tooltip" title="Enter the member's surname. Example: Smith"></i>
        </label>
        <input formControlName="surname" class="form-control" id="field-surname" name="surname" type="text" maxlength="99" placeholder="Enter surname" />
      </div>

      <!-- First Name -->
      <div class="form-group col-md-6">
        <label for="firstname">
          First Name
          <i class="fas fa-info-circle" data-toggle="tooltip" title="Enter the member's first name. Example: John"></i>
        </label>
        <input formControlName="firstname" class="form-control" id="field-firstname" name="firstname" type="text" maxlength="99" placeholder="Enter first name" />
      </div>
    </div>

    <div class="row">
      <!-- Date of Birth (optional) -->
      <div class="form-group col-md-4">
        <label for="dob">
          Date of Birth
          <i class="fas fa-info-circle" data-toggle="tooltip" title="Optional. Example: 1990-01-01"></i>
        </label>
        <input formControlName="dob" class="form-control" id="field-dob" name="dob" type="date" />
      </div>

      <!-- Age (auto-calculated, optional) -->
      <div class="form-group col-md-4">
        <label for="age">
          Age
          <i class="fas fa-info-circle" data-toggle="tooltip" title="Auto-calculated from date of birth"></i>
        </label>
        <input formControlName="age" class="form-control" id="field-age" name="age" type="text" readonly placeholder="Auto-calculated" />
      </div>

      <!-- Gender (optional) -->
      <div class="form-group col-md-4">
        <label for="gender">
          Gender
          <i class="fas fa-info-circle" data-toggle="tooltip" title="Optional"></i>
        </label>
        <select class="form-control" formControlName="gender" id="field-gender" name="gender">
          <option value="">Prefer not to say</option>
          <option value="Female">Female</option>
          <option value="Male">Male</option>
          <option value="Other">Other</option>
        </select>
      </div>
    </div>

    <div class="row">
      <!-- Admission Number -->
      <div class="form-group col-md-6">
        <label for="admission_number">
          Admission Number
          <i class="fas fa-info-circle" data-toggle="tooltip" title="Enter the student's admission number. Example: ADM-2024-001"></i>
        </label>
        <input formControlName="admission_number" class="form-control" id="field-admission_number" name="admission_number" type="text" placeholder="Enter admission number" />
      </div>

      <!-- Class -->
      <div class="form-group col-md-6">
        <label for="class">
          Class
          <i class="fas fa-info-circle" data-toggle="tooltip" title="Enter the student's class. Example: Grade 10"></i>
        </label>
        <input formControlName="class" class="form-control" id="field-class" name="class" type="text" placeholder="Enter class" />
      </div>
    </div>

    <div class="row">
      <!-- Head of Department -->
      <div class="form-group col-md-6">
        <label for="headOfDepartment">
          Head of Department
          <i class="fas fa-info-circle" data-toggle="tooltip" title="Enter the name of the head of the department. Example: John Doe"></i>
        </label>
        <input formControlName="headOfDepartment" type="text" class="form-control" id="field-headOfDepartment" name="headOfDepartment" placeholder="e.g., John Doe, Jane Smith" />
      </div>

      <!-- Address -->
      <div class="form-group col-md-6">
        <label for="address">
          Address
          <i class="fas fa-info-circle" data-toggle="tooltip" title="Enter the member's address. Example: 456 Elm St, Springfield, IL 62704"></i>
        </label>
        <input formControlName="address" class="form-control" id="field-address" name="address" type="text" placeholder="Enter address" />
      </div>
    </div>

    <div class="row">
      <!-- Primary Phone -->
      <div class="form-group col-md-6">
        <label for="primary_phone">
          Primary Phone
          <i class="fas fa-info-circle" data-toggle="tooltip" title="Enter the primary phone number. Example: (555) 555-5555"></i>
        </label>
        <input formControlName="primary_phone" class="form-control" id="field-primary_phone" name="primary_phone" type="text" placeholder="Enter primary phone" />
      </div>

      <!-- Primary Email -->
      <div class="form-group col-md-6">
        <label for="primary_email">
          Primary Email
          <i class="fas fa-info-circle" data-toggle="tooltip" title="Enter the primary email address. Example: john.doe@example.com"></i>
        </label>
        <input formControlName="primary_email" class="form-control" id="field-primary_email" name="primary_email" type="email" placeholder="Enter primary email" />
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-md-12">
        <button type="submit" class="btn btn-outline-primary" [disabled]="memberForm.invalid">Edit</button>
      </div>
    </div>

  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="closeModal()">Close</button>
</div>